<div
    class="agpr-list-card agpr-listDetailCard"
    [ngClass]="{
        'agpr-list-card-small': small,
        'agpr-listDetailCard-ignoreHeight': data.smallIcon,
    }"
    role="group"
    tabindex="0"
    [attr.aria-label]="data.title"
>
    <div class="agpr-listDetailCard-content">
        <div class="agpr-listDetailCard-contentRow">
            <div class="agpr-list-card-title-wrapper">
                <agpr-button
                    class="agpr-list-card-title"
                    [id]="id + '_listDetailCard_title'"
                    [label]="data.title"
                    [ariaLabel]="data.title"
                    [style]="buttonTypes.link"
                    (click)="navigateToRoute()"
                >
                </agpr-button>
            </div>
            <div
                *ngIf="data.date"
                class="agpr-list-card-date"
            >
                {{ data.date | changeTimeZone: preferences?.timeZone : preferences?.getDateFormatString(true) }}
            </div>
        </div>
        <div class="agpr-listDetailCard-contentRow">
            <div
                *ngIf="data.event"
                class="agpr-listDetailCard-event "
            >
                <span class="agpr-infoChip">
                    {{ data.event | localize }}
                </span>
            </div>

            <div
                *ngIf="data.status"
                class="agpr-listDetailCard-bubble"
            >
                <span class="agpr-infoChip">
                    {{ data.status | localize | titlecase}}
                </span>
            </div>

            <div class="agpr-listDetailCard-bubble">
                @if (data.surgePercentageChangePositive !== undefined && data.surgePercentageChangePositive !== null && +data.surgePercentageChangePositive >= 0) {
                    <span
                        class="agpr-listDetailCard-bubble-content"
                        [agprTooltip]="'Alerts.surge.dashboard.tooltip.' + data.metric | localize:
                            {
                                alertName: data.name,
                                changeWord: (+data.surgePercentageChangePositive >= 100 ?
                                    'Alerts.surge.dashboard.tooltip.increased' : 'Alerts.surge.dashboard.tooltip.decreased') | localize,
                                percent: +data.surgePercentageChangePositive
                            }"
                    >
                        {{ (('Alerts.surge.metrics.' + data.metric +
                        (data.metric === alertSurgeMetrics.SENTIMENT ? '.positive' : '')) | localize) +
                        ' ' + data.surgePercentageChangePositive + '%'}}
                    </span>
                }
                @if (data.surgePercentageChangeNegative !== undefined && data.surgePercentageChangeNegative !== null && +data.surgePercentageChangeNegative >= 0 && data.metric === alertSurgeMetrics.SENTIMENT) {
                    <span
                        class="agpr-listDetailCard-bubble-content"
                        [agprTooltip]="'Alerts.surge.dashboard.tooltip.negative.' + data.metric | localize:
                            {
                                alertName: data.name,
                                changeWord: (+data.surgePercentageChangeNegative >= 100 ?
                                    'Alerts.surge.dashboard.tooltip.increased' : 'Alerts.surge.dashboard.tooltip.decreased') | localize,
                                percent: +data.surgePercentageChangeNegative
                            }"
                    >
                        {{ (('Alerts.surge.metrics.' + data.metric +
                        (data.metric === alertSurgeMetrics.SENTIMENT ? '.negative' : '')) | localize) +
                        ' ' + data.surgePercentageChangeNegative + '%'}}
                    </span>
                }
            </div>

            <div
                *ngIf="data.description"
                class="agpr-listDetailCard-description"
            >
                {{ data.description | localize }} {{ data.date | changeTimeZone: preferences?.timeZone : preferences?.getDateFormatString(true, true, true) }}
            </div>
            <span
                *ngIf="data.tooltipInfo"
                role="img"
                class="fa-regular fa-circle-info agpr-list-card-infoCircle"
                [agprTooltip]="tooltipText"
                [tooltipAllowsHtml]="true"
                (mouseenter)="onMouseEnter()"
                (mouseleave)="onMouseLeave()"
                [attr.aria-label]="ariaLabelText | localize"
            ></span>
            @if (data.user) {
                <div class="agpr-listDetailCard-userName">{{ data.user }}</div>
            }
        </div>
    </div>
</div>
